import { useEffect, useState, useContext } from 'react';

import CardProductsV2 from '../cardsProductsV2/cardProductsV2';
import api from '../../api/api';

import Cookies from 'universal-cookie';
import MyContext from '../../globalState/globalState'

//importação das imagens
import comprar1 from '../../Assets/images/ico_escolha1.png'
import comprar2 from '../../Assets/images/ico_escolha2.png'
import comprar3 from '../../Assets/images/ico_escolha3.png'
import comprar4 from '../../Assets/images/ico_escolha4.png'
import comprar5 from '../../Assets/images/ico_escolha4.png'

function SectionProducts({item, tituloImg, img, texto, log}) {
    const[produtos, setProdutos] = useState([]); 
    const[produtosARQ, setProdutosARQ] = useState([]); 
    const[produtosCRT, setProdutosCRT] = useState([]); 
    const[produtosCRL, setProdutosCRL] = useState([]); 
    const[produtosTOK, setProdutosTOK] = useState([]); 
    const[produtosSEM, setProdutosSEM] = useState([]); 
    const[ready, setReady] = useState(false); 
    let count = 0;
    const accessTokenGS = useContext(MyContext);
    const planoPag = accessTokenGS.planoPag;
    let session = "";
    let rubricaInicial = 0;
    // let ast = accessTokenGS.ast;


    const ARQ = [];
    const CRT = [];
    const CRL = [];
    const TOK = [];
    const SEM = [];
    
    const cookies = new Cookies();
    // let newDate = Date.parse(new Date());

    // const accesstoken = cookies.get('Session');
    // console.log(accesstoken[0], accesstoken[1], accesstoken[2]);

    //getSession
    // const [accessTokenSession, setAccessTokenSession]  = useState('');
    // const [refreshTokenSession, setRefreshTokenSession] = useState('');
    // const [dateSession, setDateSession] = useState('');
    // const cookies = new Cookies();
    // const interval = 15 * 60 * 1000;

    useEffect(() => {
        async function getVar(){
            await getSessionParams();
        }
        getVar()
    }, []);

    async function getSessionParams(){
      session = accessTokenGS.accessTokenGS;
      rubricaInicial = accessTokenGS.firstProduct? parseInt(accessTokenGS.firstProduct) : 22;
      if(session !== ''){
        await getProducts();
        getMidia();
      }
    }
    //pegar o whitelabel para ver se tem o produto inicial

    async function getProducts(){
      if(session){
        await api.get("ws_produto/?rubri_inid_rubricamodulo=4",
          { headers: {"Authorization" : `Bearer ${session}`}, 
            params: {produ_dmtp_certificadodigital: `${item}`}
          }
        ).then((response) => {
          setProdutos(response.data.detalhe[0].produtos);
          separarProdutos(response.data.detalhe[0].produtos);
          const firstItem = response.data.detalhe[0].produtos.find(element => element.rubri_inid_rubricaproduto === rubricaInicial)//{
          if(firstItem !== undefined){
            sessionStorage.setItem("@App:ecnpjA1", JSON.stringify(firstItem)) 
          }
        }).catch((error) => {
          // console.log("não autorizado: "+ error);
          getProducts()
        });
      }else{
        getProducts()
      }
    }
    const getSession = () => {
      try{
        api.post("ws_refreshtoken/", {
          refresh_token: log.refresh_token,
        }).then((response) => {
          // console.log("response volta");
          let date = new Date();
          const session = [response.data.detalhe.access_token, response.data.detalhe.refresh_token, date]
          cookies.set('Session', session);
          getProducts();
        }).catch((error) => {
          console.log("erro no refresh: "+error);
          //getNewSession();
        });
      }catch(err){

      }
    }
    const getNewSession = () => {
      try{
        api.post("ws_login/", {
          clapi_vcds_code: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDT05ORUNUIFMvQSIsInN1YiI6IkNUIFBsdXMiLCJpYXQiOjE2NTU5OTM2MzEsImF1ZCI6ImN0cGx1cyJ9.Gzzi__vu10piMvzjM6wb07kC5pNQ3QWGuGABRzhAGq8",
        }).then((response) => {
          let date = new Date();
          const session = [response.data.detalhe.access_token, response.data.detalhe.refresh_token, date]
          cookies.set('Session', session);
          // console.log(session[2]);
          // console.log(Date.parse(session[2]) + " - " +Date.parse(new Date()));
          getProducts();
        });
      }catch(err){

      }
    }
    const getMidia = () => {
      // console.log(session);
      api.get("ws_produto/?rubri_inid_rubricamodulo=4",
        { headers: {"Authorization" : `Bearer ${session}`}, 
          params: {
            produ_dmtp_certificadodigital: `${item}`,
            produ_dmtp_midia: "CRT"
        }
      }).then((response) => {
        //console.log(response.data)
      }).catch(() => {

      })
    }
    const separarProdutos = (produtos) => {
      count += 1;
      if(count <= 1){
        produtos.forEach(element => {
          let midiaDef = element.produ_dmtp_midia +'';
          switch (midiaDef){
            case "ARQ":
              ARQ.push(element);
              break;
            case "CRT":
              CRT.push(element);
              break;
            case "CRL":
              CRL.push(element);
              break;
            case "TOK":
              TOK.push(element);
              break;
            case "SEM":
              SEM.push(element);
              break;
          }
        });
  
        setProdutosARQ(ARQ);
        setProdutosCRL(CRL);
        setProdutosCRT(CRT);
        setProdutosSEM(SEM);
        setProdutosTOK(TOK);
        setReady(true);
      }
      
    }
    //console.log(ready);
    const chamaArq = () => {
      let itemLayout = item + '';
      if(itemLayout === "NFE"){
        return (
          <>
          {/* <CardProductsV2 item={produtosSEM} card={'4'} layout={'col-md-1'}/> */}
            <CardProductsV2 log={log} item={produtosARQ} card={'1'} layout={'col-md-3'} img={comprar1} planoPag={planoPag}/>
            <CardProductsV2 log={log} item={produtosCRL} card={'2'} layout={'col-md-3'} img={comprar2} planoPag={planoPag}/>
            
            <CardProductsV2 log={log} item={produtosCRT} card={'3'} layout={'col-md-3'} img={comprar3} planoPag={planoPag}/>

            <CardProductsV2 log={log} item={produtosTOK} card={'5'} layout={'col-md-3'} img={comprar5} planoPag={planoPag}/>
            {/* <CardProductsV2 item={produtosSEM} card={'4'} layout={'col-md-4'}/> */}
          </>
        )
      }else{
        return (
          <>
            <CardProductsV2 log={log} item={produtosARQ} card={'1'} layout={'col-md-2'} img={comprar1} planoPag={planoPag}/>
            <CardProductsV2 log={log} item={produtosCRL} card={'2'} layout={'col-md-2'} img={comprar2} planoPag={planoPag}/>
            <CardProductsV2 log={log} item={produtosCRT} card={'3'} layout={'col-md-2'} img={comprar3} planoPag={planoPag}/>
            <CardProductsV2 log={log} item={produtosSEM} card={'4'} layout={'col-md-2'} img={comprar4} planoPag={planoPag}/>
            <CardProductsV2 log={log} item={produtosTOK} card={'5'} layout={'col-md-2'} img={comprar5} planoPag={planoPag}/>
          </>
        )
      } 
    }
   
    return (
      <div className="Sections mtb-70">
       
          <div className='container'>
          <div className='row'>
            <div className='col-md-12 text-center img-products'>
              <img src={img} alt={tituloImg}/>
            </div>
            <div className='col-md-12'>
              <p></p>
              <p className='text-section'>{texto}</p>
            </div>
          </div>
          <div className='row d-flex justify-content-center'>            
            {ready ? chamaArq() :null}
          </div>
        </div>
      </div>
    );
  }
  
  export default SectionProducts;